import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Descriptions, Tag, Space, Popconfirm, Form, DatePicker, Select, Input, message, Divider } from "antd";
import { ModalItem, ButtonItem, fmtFechaDia, fechaDiaParaPayload } from "../../../Components/Items";
import { momentDeFechaDia } from "../../../Components/fmtFechaDia";
import HistorialTrabajo, { COLOR_ESTATUS } from "./HistorialTrabajo";

const { Option } = Select;

// Detalle de una pieza asignada en el tablero "Por persona": pausar / reanudar, reasignar,
// corregir fecha de inicio y notas, quitar la asignacion y terminar (lo abre el tablero).
//
// props: visible, tarjeta, etapa, onCerrar(huboCambios), onTerminar(tarjeta), onVerAgrupacion(id)
class ModalDetalleAsignacion extends Component {
  formRef = React.createRef();
  state = { loading: false, modo: null };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) this.setState({ modo: null });
  }

  llamar = async (ruta, datos, exito) => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        `asignacionesAgrupacion/${ruta}`,
        { empresaId: this.props.empresaId, asignacionId: this.props.tarjeta?.asignacionId, ...datos },
        { headers: this.props.headersToken }
      );
      this.setState({ loading: false });
      if (res.data.success === 2) {
        message.success(exito);
        this.props.onCerrar(true);
      } else {
        message.warning(res.data.message || "No se pudo guardar");
      }
    } catch (err) {
      this.setState({ loading: false });
      console.error(err);
      message.error("Error al conectar con el servidor");
    }
  };

  guardarModo = async () => {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch (e) {
      return;
    }
    if (this.state.modo === "editar") {
      this.llamar(
        "editarAsignacion",
        { fechaInicio: fechaDiaParaPayload(values.fechaInicio), notas: values.notas || "" },
        "Asignación actualizada"
      );
    } else if (this.state.modo === "reasignar") {
      this.llamar(
        "reasignarAsignacion",
        { empleadoId: values.empleadoId, fecha: fechaDiaParaPayload(values.fecha) },
        "Pieza reasignada"
      );
    }
  };

  renderFormularioModo() {
    const { tarjeta, etapa } = this.props;
    const inicio = momentDeFechaDia(tarjeta?.fechaInicio);
    const fueraDeRango = (fecha) =>
      fecha && (fecha > moment().endOf("day") || (inicio && fecha < inicio.clone().startOf("day")));

    if (this.state.modo === "editar") {
      return (
        <Form
          ref={this.formRef}
          layout="vertical"
          key="editar"
          initialValues={{ fechaInicio: inicio, notas: tarjeta?.notas || "" }}
        >
          <Form.Item name="fechaInicio" label="Fecha de inicio" rules={[{ required: true, message: "Captura la fecha" }]}>
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              allowClear={false}
              disabledDate={(fecha) => fecha && fecha > moment().endOf("day")}
            />
          </Form.Item>
          <Form.Item name="notas" label="Notas">
            <Input.TextArea rows={2} maxLength={500} />
          </Form.Item>
        </Form>
      );
    }

    const otros = (etapa?.personal || []).filter((p) => String(p._id) !== String(tarjeta?.empleadoId));
    return (
      <Form ref={this.formRef} layout="vertical" key="reasignar" initialValues={{ fecha: moment() }}>
        <Form.Item name="empleadoId" label="Pasar a" rules={[{ required: true, message: "Elige a la persona" }]}>
          <Select placeholder="Elige a la persona" showSearch optionFilterProp="children">
            {otros.map((p) => (
              <Option key={String(p._id)} value={String(p._id)}>
                {p.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="fecha"
          label="A partir de"
          tooltip="Si es el mismo día en que empezó, solo se corrige la persona. Si no, la asignación anterior queda como 'Reasignada' y sigue saliendo en el reporte de quien la trabajó."
          rules={[{ required: true, message: "Captura la fecha" }]}
        >
          <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} allowClear={false} disabledDate={fueraDeRango} />
        </Form.Item>
      </Form>
    );
  }

  render() {
    const { visible, tarjeta, etapa } = this.props;
    if (!tarjeta) return null;
    const pausada = tarjeta.estatus === 2;

    return (
      <ModalItem
        title={`${tarjeta.numero ? "#" + tarjeta.numero + " · " : ""}${tarjeta.especie || ""}`}
        visible={visible}
        spinning={this.state.loading}
        onCancel={() => this.props.onCerrar(false)}
        width={760}
        paddingTop
      >
        <Descriptions size="small" column={2} bordered>
          <Descriptions.Item label="Etapa">{etapa?.nombre}</Descriptions.Item>
          <Descriptions.Item label="Persona">{tarjeta.personaNombre}</Descriptions.Item>
          <Descriptions.Item label="Cliente">{tarjeta.clienteNombre || "—"}</Descriptions.Item>
          <Descriptions.Item label="Forma / posición">{tarjeta.detalle || "—"}</Descriptions.Item>
          <Descriptions.Item label="Inicio">{fmtFechaDia(tarjeta.fechaInicio)}</Descriptions.Item>
          <Descriptions.Item label="Días hábiles">{tarjeta.diasHabiles}</Descriptions.Item>
          <Descriptions.Item label="Fecha de entrega">{fmtFechaDia(tarjeta.fechaEntrega)}</Descriptions.Item>
          <Descriptions.Item label="Estatus">
            <Tag color={COLOR_ESTATUS[tarjeta.estatusTexto] || "default"}>{tarjeta.estatusTexto}</Tag>
            {tarjeta.horarioExtra && <Tag color="purple">Horario extra</Tag>}
          </Descriptions.Item>
          {tarjeta.notas && (
            <Descriptions.Item label="Notas" span={2}>
              {tarjeta.notas}
            </Descriptions.Item>
          )}
        </Descriptions>

        <Space wrap style={{ marginTop: 12 }}>
          <ButtonItem type="primary" onClick={() => this.props.onTerminar(tarjeta)}>
            Terminar
          </ButtonItem>
          <ButtonItem
            onClick={() =>
              this.llamar("cambiarEstatusAsignacion", { estatus: pausada ? 1 : 2 }, pausada ? "Pieza reanudada" : "Pieza pausada")
            }
          >
            {pausada ? "Reanudar" : "Pausar"}
          </ButtonItem>
          <ButtonItem onClick={() => this.setState({ modo: "reasignar" })}>Reasignar</ButtonItem>
          <ButtonItem onClick={() => this.setState({ modo: "editar" })}>Editar fecha y notas</ButtonItem>
          <Popconfirm
            title="¿Quitar la asignación? La pieza regresa a 'Por asignar' y no sale en el reporte."
            okText="Sí"
            cancelText="No"
            onConfirm={() => this.llamar("cancelarAsignacion", {}, "Asignación quitada")}
          >
            <ButtonItem danger>Quitar asignación</ButtonItem>
          </Popconfirm>
          <ButtonItem onClick={() => this.props.onVerAgrupacion(tarjeta.agrupacionId)}>Ver agrupación</ButtonItem>
        </Space>

        {this.state.modo && (
          <>
            <Divider style={{ margin: "12px 0" }} />
            {this.renderFormularioModo()}
            <Space>
              <ButtonItem onClick={() => this.setState({ modo: null })}>Cancelar</ButtonItem>
              <ButtonItem type="primary" onClick={this.guardarModo}>
                Guardar
              </ButtonItem>
            </Space>
          </>
        )}

        <HistorialTrabajo agrupacionId={tarjeta.agrupacionId} recargar={visible} />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalDetalleAsignacion);
